import { languages, type LanguageType } from '@aikoa/common'
import { z as z3 } from 'zod'
import { env } from '~/env'

export const z3translatableFieldSchema = z3.array(
  z3.object({
    lang: z3.enum(languages),
    text: z3.string(),
  })
)

export const DEFAULT_LANGUAGE: LanguageType = env.EXPO_PUBLIC_DEFAULT_LANGUAGE as LanguageType
